import React from "react";
import { SiYoutube, SiXiaohongshu, SiPinterest, SiBilibili, SiTiktok, SiInstagram, SiFacebook, SiApplepodcasts, SiSpotify, SiWechat } from "react-icons/si";
import { TbNote } from "react-icons/tb";
import { FaRegNoteSticky } from "react-icons/fa6";
import { motion } from "framer-motion";

const COPYRIGHT = {
    EN: "All images, illustrations, and educational content on this site are protected by copyright and may not be copied, reproduced, or distributed without written permission.",
    JP: "このサイトの画像・イラスト・学習コンテンツはすべて著作権により保護されており、書面による許可なく複製・転載・配布することを禁止します。",
    ZH: "本网站的图片、插图及学习内容均受版权保护，未经书面许可，不得复制、转载或分发。",
};

export default function Footer({ language, onWeixinClick }) {
    return (
        <footer className="relative bg-[#b5435f] text-white py-12 flex flex-col items-center gap-6">

            {/* SNSアイコン中央配置 */}
            <div className="flex flex-wrap gap-6 text-4xl justify-center">
                <a href="https://www.youtube.com/channel/UCXFOpp-skK2-psYqVwYOj1g" target="_blank" rel="noopener noreferrer" className="hover:text-red-600 transition-colors">
                    <SiYoutube />
                </a>
                <a href="https://jp.pinterest.com/hanapinjapanese/" target="_blank" rel="noopener noreferrer" className="hover:text-[#E60023] transition-colors">
                    <SiPinterest />
                </a>
                <a href="https://www.tiktok.com/@hanapinjapanese" target="_blank" rel="noopener noreferrer" className="hover:text-black transition-colors">
                    <SiTiktok />
                </a>
                <a href="https://www.instagram.com/hanapinjapanese" target="_blank" rel="noopener noreferrer" className="hover:text-[#833AB4] transition-colors">
                    <SiInstagram />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61584868636111" target="_blank" rel="noopener noreferrer" className="hover:text-black transition-colors">
                    <SiFacebook />
                </a>
                <a href="https://space.bilibili.com/3706935259957265" target="_blank" rel="noopener noreferrer" className="hover:text-[#1877F2] transition-colors">
                    <SiBilibili />
                </a>
                <a href="https://podcasts.apple.com/jp/podcast/hanapin-emimaru-pre-n5-fun-japanese-conversations/id1896842557?l=en-US" target="_blank" rel="noopener noreferrer" className="hover:text-[#B150E2] transition-colors">
                    <SiApplepodcasts />
                </a>
                <a href="https://open.spotify.com/show/0FeUtrzcEIW2GDg2NXofrv?si=QueySUwFTT2zY1IM3z86CQ" target="_blank" rel="noopener noreferrer" className="hover:text-[#1DB954] transition-colors">
                    <SiSpotify />
                </a>
                <a href="https://note.com/hanapinjapanese" target="_blank" rel="noopener noreferrer" className="hover:text-black transition-colors">
                    <TbNote />
                </a>
                <button onClick={onWeixinClick} className="hover:text-[#07c160] transition-colors focus:outline-none">
                    <SiWechat />
                </button>
            </div>

            {/* コピーライト */}
            <p className="text-sm text-white/80 mt-2 text-center">
                <a href="/privacypolicy" target="_blank" rel="noopener noreferrer" className="hover:text-black transition-colors">
                    Our Privacy Policy
                </a>
            </p>
            <p className="text-sm text-white/80 mt-0 text-center">
                © {new Date().getFullYear()} Fujiyama, Inc. All rights reserved.
            </p>
            <p className="text-xs text-white/60 mt-1 text-center max-w-md px-4">
                {COPYRIGHT[language] || COPYRIGHT.EN}
            </p>
        </footer>
    );
}
